'use client';
import Image from 'next/image';
import Link from 'next/link';
import './pageNotFound.scss';
import { useRouter } from 'next/navigation';

export default function PageNotFound() {
  const router = useRouter(); // use it inside component

  return (
    <div className="page-notfound">
      <div className="lights-bulb-wrapper">
        <Image
          src="/n_images/Animation-lightbulb-idea.gif"
          alt="Lightbulb with clouds"
          width={300}
          height={300}
          priority
          unoptimized={true}
        />
      </div>
      <div className="content">
        <h1>Let&apos;s get you somewhere better!</h1>
        <p className="lead">
          Try going&nbsp;
          <Link onClick={() => router.back()} href={''}>
            back
          </Link>{' '}
          &nbsp;or&nbsp;
          <Link href="/">home</Link>.
        </p>
      </div>
    </div>
  );
}
